/** Returns an array of numbers from `start` up to, but not including, `end`. */
export function range(start: number, end: number) {
  return Array(end - 1 - start + 1)
    .fill(null)
    .map((_, index) => start + index);
}
